import TrendMatchQuota from './TrendMatchQuota';


export default TrendMatchQuota;
